export function CheckMarkIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            {/* Gradient circle (24x24, matches XCircleIcon sizing) */}
            <path
                d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z"
                fill="url(#paint0_linear_4385_12528)"
            />

            {/* White check mark – thicker, within 24x24 circle */}
            <path
                d="M8.5 12.5L11 15L15.5 9.5"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_4385_12528"
                    x1="6.5"
                    y1="5"
                    x2="17"
                    y2="20.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#52D17C" />
                    <stop offset="1" stopColor="#22918B" />
                </linearGradient>
            </defs>
        </svg>
    );
}